import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    userInfo: null
  },
  mutations: {
    login(state, loginInfo) {
      state.userInfo = loginInfo;
      window.localStorage.removeItem("userInfo")
      window.localStorage.removeItem("token");
      window.localStorage.setItem("userInfo", JSON.stringify(loginInfo))
      window.localStorage.setItem("token", loginInfo.access_token);
    },
    logout(state) {
      state.userInfo = null;
      window.localStorage.removeItem("userInfo")
      // window.localStorage.setItem("userInfo",JSON.stringify(loginInfo))
      window.localStorage.removeItem("token");
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js